import { AbilityCan, AbilitySubjects, UserRole } from '../../enums';
import { IAbilityFunction, IAbilityUser } from '../abilities.types';

export function defineAbilitiesForInvoices(user: IAbilityUser, allow: IAbilityFunction, _: IAbilityFunction) {
    if (user.role === UserRole.ADMIN || user.role === UserRole.EMPLOYEE)
        allow(AbilityCan.READ, AbilitySubjects.INVOICES);
}
